import React from 'react';
import PropTypes from 'prop-types';
import {ReactComponent as ErrorSvg} from "../assets/svg/error.svg";
import classNames from "classnames";

interface FormInputErrorProps {
    color?: string;
    children?: React.ReactNode;
    className?: string;
}

const propTypes = {
  color: PropTypes.string,
}

const defaultProps = {
  color: null,
}

const FormInputError = ({
  color, children, className
}: FormInputErrorProps) => {
  const classes = classNames(className, 'd-flex', 'align-items-center')

  return (
    <div className={classes}>
      <ErrorSvg/>
      <div className="form-error" style={color? {color: color}: {}}>
        {children}
      </div>
    </div>
  );
}

FormInputError.propTypes = propTypes;
FormInputError.defaultProps = defaultProps;

export default FormInputError;
